import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'
import { Button } from '../../../components/Button/Button'
import { type StepStatus } from '../domain/flow'
import { StepRail } from './StepRail'
import styles from '../AccountOpeningWizard.module.scss'

interface FlowSectionProps {
  number: number
  icon?: string
  title: string
  subtitle: string
  status: StepStatus
  isLast: boolean
  collapsed: boolean
  onToggleCollapsed: () => void
  headerActions?: ReactNode
  hasInfoColumn: boolean
  infoContent?: ReactNode
  children: ReactNode
}

export const FlowSection: FC<FlowSectionProps> = ({
  number,
  icon,
  title,
  subtitle,
  status,
  isLast,
  collapsed,
  onToggleCollapsed,
  headerActions,
  hasInfoColumn,
  infoContent,
  children,
}) => (
  <div className='d-flex zocks-gap-1.5'>
    <StepRail number={number} icon={icon} status={status} isLast={isLast} />

    <section
      className={classNames('d-flex flex-column zocks-gap-1.5 flex-grow-1 pb-4', { [styles.inactive]: status === 'inactive' })}
      aria-disabled={status === 'inactive'}
    >
      <div className='d-flex flex-column zocks-gap-0.5'>
        <div className='d-flex align-items-center justify-content-between zocks-gap-1'>
          <h6 className='mb-0'>{title}</h6>
          <div className='d-flex align-items-center zocks-gap-0.5'>
            {collapsed ? null : headerActions}
            {status === 'inactive' ? null : (
              <Button variant='secondary' aria-label={collapsed ? `Expand ${title}` : `Collapse ${title}`} onClick={onToggleCollapsed}>
                <i className={classNames('bi', collapsed ? 'bi-chevron-down' : 'bi-chevron-up')} />
              </Button>
            )}
          </div>
        </div>
        <p className={classNames('paragraph-small zocks-text-gray-600 mb-0', styles.sectionSubtitle)}>{subtitle}</p>
      </div>

      {collapsed ? null : children}
    </section>

    {hasInfoColumn ? <div className={styles.infoColumn}>{collapsed || !infoContent ? null : <div className={styles.rail}>{infoContent}</div>}</div> : null}
  </div>
)
